import { ILayout, ILayoutMenuItems } from "../interfaces/shared/ILayout";

export const structureRoutes = (routes: ILayout[]): ILayoutMenuItems[] => {
  const flat: ILayoutMenuItems[] = [];

  routes.forEach((route) => {
    if (route.hasSub && Array.isArray(route.parent)) {
      route.parent.forEach((parentRoute) => {
        if (Array.isArray(parentRoute.menuItems)) {
          flat.push(...parentRoute.menuItems);
        }
      });
    } else {
      flat.push(route as unknown as ILayoutMenuItems);
    }
  });

  return flat;
};
